import styled from 'styled-components';

import { Button } from '@olxbr/ds-web';

export const ContactsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
`;

export const ContactWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const IconContainer = styled.div`
  padding-right: var(--spacing-stack-nano);
`;

export const ActionButton = styled(Button)`
  font-size: var(--font-size-xxs);

  @media (min-width: 1030px) {
    font-size: var(--font-size-xs);
  }
`;
